exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.grecaptcha-badge{\n\tdisplay: none !important;\n}\n\n", ""]);

// exports
